import React, { PureComponent } from 'react';
import { routerShape } from 'react-router';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { authConnect, UserProp } from 'auth';
import Paginator, { Control, Container, Pages } from 'components/paginator';
import SubscribeModal from 'components/subscribe-modal';
import { FavoritesButton } from 'subsys/favorites';
import config from 'src-sites/forum/const-config';
import linksForum from 'src-sites/forum/links';

import TopicList from '../../common/topic-list';
import ClubUsers from './club-users';

const bemClassesUsers = new Bem('tabUsers');

const {
  limitCountClubList,
  limitCountUserClubs
} = config;

// Check page and show content
@authConnect()
export default class ClubContent extends PureComponent {
  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      status: PropTypes.string,
      page: PropTypes.string
    }),
    data: PropTypes.shape({}),
    router: routerShape,
    auth: UserProp,
    selectedThemes: PropTypes.arrayOf(PropTypes.shape({})),
    onHandleSelectTheme: PropTypes.func,

    // Preloaded data
    preloadedClubTopicList: PropTypes.shape({}),
    preloadedClubUsersList: PropTypes.shape({})
  };

  render() {
    const {
      params = {}, auth = {}, router, selectedThemes, onHandleSelectTheme,
      preloadedClubTopicList, preloadedClubUsersList, data
    } = this.props;

    if (params.status === 'users') {
      return (
        <Paginator
          updateEvent="updateClubList"
          url="forum/users-club"
          query={{ 'club-id': params.id }}
          limit={limitCountUserClubs}
          changeUrl
          page={params.page}
          preloaded={preloadedClubUsersList}
        >
          <Control />
          <Container {...bemClassesUsers('paginator')} injectPropName="data">
            <ClubUsers auth={auth} params={params} />
          </Container>
          <Pages
            linkBuilder={linksForum.pageClub}
            linkBuilderProps={{
              paramsTitle: params.title,
              id: params.id,
              usersPage: params.status
            }}
            router={router}
            // withPageChange
          />
        </Paginator>
      );
    }

    return (
      <Paginator
        url="forum/topic-list"
        updateEvent="updateClubTopics"
        query={{
          'forum-id': params.id,
          'order-by-desc': 'topic_last_post_time',
          'show-unread-status': 1,
          'forum-type-club': 1
        }}
        queryJson
        limit={limitCountClubList}
        changeUrl
        page={params.page}
        preloaded={preloadedClubTopicList}
        withTopPages
      >
        <Control />
        <Container injectPropName="data">
          {/* Get topics with links for topic club */}
          <TopicList
            router={router}
            auth={auth}
            selectedThemes={selectedThemes}
            onHandleSelectTheme={onHandleSelectTheme}
          />
        </Container>
        <Pages
          linkBuilder={linksForum.pageClub}
          linkBuilderProps={{
            paramsTitle: params.title,
            id: params.id
          }}
          router={router}
          // withPageChange
          elementsRight={
            <React.Fragment>
              <SubscribeModal title="Подписаться на Клуб" />
              <FavoritesButton
                // entity={favoriteGroups.GROUP_FORUM}
                entityId={this.props.params.id}
                // subgroup={favoriteGroups.SUBGROUP_FORUM_CLUB}
                inFavorites={!!data.favorites}
              />
            </React.Fragment>
          }
        />
      </Paginator>
    );
  }
}
